module.exports = __webpack_public_path__ + "img/seat-of-power.75306856.webp";